import React, { useState } from "react";
import { Dropdown, Button, message } from "antd";
import { DownOutlined } from "@ant-design/icons";
import ModalEditarEvento from "../ModalEditarEvento";
import ModalEditarDatosEvento from "../ModalEditarDatosEvento";
import SendWoT from "../../components/sendWoT";
import ModalActividadesEventos from "./ModalActividadesEventos";
import ModalFalsaAlarma from "../../generales/ModalFalsaAlarma";
import ModalIntencion from "./ModalIntencion";
import ModalInformePDF from "../../generales/ModalInformePDF";
import ModalConfirmacion from "../../generales/ModalConfirmacion";
import CostModal from "../../components/CostModal";
import eventService from "../../../../services/eventService";
import useAuth from "../../../../hooks/useAuth";
import { useUser } from "../../../../context/UserContext";
import ParticipantModal from "../../../../pages/eventos/components/ParticipantModal";

const MenuBoton = ({ item, fetchData }) => {
  const [show, setShow] = useState(false);
  const [showNotificaciones, setShowNotificaciones] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [showEditarDatos, setShowEditarDatos] = useState(false);
  const [showActividades, setShowActividades] = useState(false);
  const [showModalInforme, setModalInforme] = useState(false);
  const [showCosto, setCosto] = useState(false);
  const [showConfirmacion, setConfirmacion] = useState(false);
  const [showImplicado, setImplicado] = useState(false);
  const [showIntencion, setIntencion] = useState(false);
  const [LoadingButon, setLoadingButon] = useState(false);
  const { session } = useAuth();
  const user = useUser();

  const funcionBoton = async () => {
    setLoadingButon(true);
    Promise.all(
      item.protocols.map(async (protocolo) => {
        let registro = {
          state: "InProgress",
        };
        await editarProtocolo(registro, item.id, protocolo);
      })
    ).then(() => {
      setLoadingButon(false);
      fetchData();
      setConfirmacion(false);
    });
  };

  const editarProtocolo = async (registro, eventId, protocol) => {
    try {
      await eventService.EditarEvento(eventId, registro, user.idToken);
      message.success("Solicitud realizada");
    } catch (error) {
      console.error("Error al editar el protocolo:", error);
      message.error("No se logró realizar la consulta");
    }
  };

  const handleMenuClick = ({ key }) => {
    switch (key) {
      case "0":
        setConfirmacion(true);
        break;
      case "1":
        setShowActividades(true);
        break;
      case "2":
        setShow(true);
        break;
      case "4":
        setModalInforme(true);
        break;
      case "5":
        setShowNotificaciones(true);
        break;
      case "6":
        setCosto(true);
        break;
      case "8":
        setImplicado(true);
        break;
      case "9":
        setIntencion(true);
        break;
      case "10":
        setShowEditarDatos(true);
        break;
      default:
        break;
    }
  };

  // Configuración del menú usando la nueva API
  const menuItems = [
    ...(item.state === "Open" ||
    (item.state === "InProgress" && session?.roles?.events?.isAllowedtoUpdate)
      ? [
          {
            key: "0",
            label: "Iniciar PARP",
          },
        ]
      : []),
    ...(item.state === "InProgress" && session?.roles?.events?.isAllowedtoUpdate
      ? [
          {
            key: "1",
            label: "Ver PARP",
          },
        ]
      : []),
    ...(session?.roles?.events?.isAllowedtoUpdate
      ? [
          {
            key: "2",
            label: "Editar evento",
          },
        ]
      : []),
    ...(item.state === "Open"
      ? [
          {
            key: "10",
            label: "Editar datos del evento",
          },
        ]
      : []),
    ...(item.state === "Closed" || item.state === "FalseAlarm"
      ? [
          {
            key: "4",
            label: "Informe Pdf",
          },
        ]
      : []),
    {
      key: "5",
      label: "Notificar",
    },
    ...(item.state === "Closed" && session?.roles?.events?.isAllowedtoLoadCost
      ? [
          {
            key: "6",
            label: "Asignar Costo",
          },
        ]
      : []),
    {
      key: "8",
      label: "Añadir Implicado",
    },
    {
      key: "9",
      label: "Añadir Intención",
    },
  ];

  return (
    <>
      <Dropdown
        menu={{ items: menuItems, onClick: handleMenuClick }}
        placement="bottomLeft"
      >
        <Button>
          <DownOutlined />
        </Button>
      </Dropdown>

      <ModalEditarEvento open={show} setOpen={setShow} item={item} />
      <ModalEditarDatosEvento
        open={showEditarDatos}
        setOpen={setShowEditarDatos}
        item={item}
        fetchData={fetchData}
      />
      <ModalActividadesEventos
        setOpen={setShowActividades}
        open={showActividades}
        item={item}
      />
      <ModalInformePDF
        open={showModalInforme}
        setOpen={setModalInforme}
        item={item}
      />

      <ModalConfirmacion
        open={showConfirmacion}
        setOpen={setConfirmacion}
        funtion={funcionBoton}
        title="¿Está seguro de que desea iniciar los PARP?"
        message="Una vez iniciados los protocolos, no se podrán eliminar del evento. Por favor, valide los protocolos en la edición de eventos antes de iniciarlos."
        LoadingButon={LoadingButon}
      />

      <ModalFalsaAlarma
        open={showModal}
        setOpen={setShowModal}
        item={item}
        fetchData={fetchData}
      />
      <CostModal
        open={showCosto}
        setOpen={setCosto}
        pantalla=""
        record={item}
        fetchData={fetchData}
      />

      <ParticipantModal
        open={showImplicado}
        setOpen={setImplicado}
        record={item}
      ></ParticipantModal>

      <SendWoT
        open={showNotificaciones}
        setOpen={setShowNotificaciones}
        record={item}
      />

      <ModalIntencion
        open={showIntencion}
        setOpen={setIntencion}
        item={item}
        fetchData={fetchData}
      />
    </>
  );
};

export default MenuBoton;
